import { render, staticRenderFns } from "./EmailExistsModal.vue?vue&type=template&id=a876c60c"
import script from "./EmailExistsModal.vue?vue&type=script&lang=js"
export * from "./EmailExistsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports